module.exports = __webpack_public_path__ + "static/media/Apple iPad Air Space Grey.c4fa1e54.png";